// extracted by mini-css-extract-plugin
export default {"wrapper":"pIBUlt6B75lCJ4ZnyaYj"};